import React from "react";

import { Stack, Typography } from "@mui/material";

const CopyrightSection = ({ hidden, padding }) => {
  const currentYear = new Date().getFullYear().toString();

  if (hidden) {
    return null;
  }
  return (
    <Stack gap={1} p={padding}>
      <Typography
        variant="mutedMeta"
        sx={{
          color: "#8A9BB0",
          whiteSpace: "normal",
          fontSize: "calc(9px * var(--unicity-font-scale, 1)) !important",
          fontWeight: "400"
        }}
      >
        {`© ${currentYear} Copyright Unicity International, Inc.`}&nbsp;
        All rights reserved.
      </Typography>
      <Typography
        variant="mutedMeta"
        sx={{
          color: "#8A9BB0",
        }}>
        Unicity Office Version {process.env.REACT_APP_VERSION}
      </Typography>
    </Stack>
  )
}

export { CopyrightSection }
